import React from 'react';

const getDaySuffix = (day) => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  if (day > 3 && day < 21) return `${day}${suffixes[0]}`;
  return `${day}${suffixes[day % 10] || suffixes[0]}`;
};

const ExpiryInfo = ({ ends, numIdeas, classes, myChallengeHide }) => {
  const expiryDate = new Date(ends);
  const currentDate = new Date();
  const expired = expiryDate <= currentDate;
  const diffDays = Math.ceil((expiryDate - currentDate) / (1000 * 60 * 60 * 24));

  const expiryDateStr = expired
    ? `${getDaySuffix(expiryDate.getDate())} ${expiryDate.toLocaleString('en-US', {
        month: 'short',
        year: 'numeric',
      })}`
    : null;

  return (
    <div className={`${classes.expiry_box} ${expired ? 'expired' : ''}`}>
      <span className={`${classes.expiry_text} ${expired ? 'expired' : ''}`}>
        {expired ? 'Expired on ' : 'Expires in '}
        <span className={`${classes.bold_expiry} ${expired ? 'expired' : ''}`}>
          {expired ? expiryDateStr : diffDays}
        </span>
        {!expired && ' days'}
      </span>
      {!myChallengeHide && (
        <span className={`${classes.expiry_text} ${expired ? 'expired' : ''}`}>
          Idea tagged{' '}
          <span className={`${classes.bold_expiry} ${expired ? 'expired' : ''}`}>
            {numIdeas}
          </span>
        </span>
      )}
    </div>
  );
};

export default ExpiryInfo;
